import { useState, useContext } from 'react';

import { RightOutlined } from '@ant-design/icons';

import { CustomScrollbar } from './CustomScrollbar.style';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';

function headBuriedPoint(op, data) {
  const current_h = window.location.href;
  if (data) {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: op,
      data: { current_href: current_h, ...data },
    });
  } else {
    buriedPoint({ cp: 'top_header', ty: 'click', op: op });
  }
}
const SubCatalogPop = ({ subCatalogList, currentParentName, resourceData, onlySScreen, currentParentIdx }) => {
  /**BOM相关的逻辑 */
  const isBomChildPage = false; // BOM 页面要做特殊判断
  /**BOM相关的逻辑 end */
  const isMroSubCatalog = currentParentName?.includes('工业品') || currentParentName?.includes('仪器仪表');

  let subPopClassName = 'absolute z-10 right-[-958px] top-[-20px] w-[958px] bg-transparent';
  subPopClassName = Utils.addBigScreenClassName(subPopClassName, '_lg:w-[1310px] _lg:right-[-1310px]', onlySScreen);

  let subPopContentClassName = `absolute right-0 p-[20px] w-[948px] ${isMroSubCatalog ? 'h-[521px] overflow-y-scroll' : 'min-h-[521px]'} bg-white rounded-[10px] border border-lcBlue border-solid`;
  subPopContentClassName = Utils.addBigScreenClassName(subPopContentClassName, '_lg:w-[1300px]', onlySScreen);

  return (
    <section className={subPopClassName} data-spm={'ca' + currentParentIdx}>
      <CustomScrollbar className={subPopContentClassName}>
        <section>
          {subCatalogList.map((sonCatalog, pIdx) => {
            const hasCatalogImage = sonCatalog.hasCatalogImage;
            let ktxxArea = null; // 看图选型
            if (hasCatalogImage) {
              ktxxArea = isMroSubCatalog ? (
                <a
                  className="h-[26px] w-[102px] bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con_active.svg)]"
                  catalogName={sonCatalog.catalogName}
                  href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`}
                  target="_blank"
                  data-spm={pIdx + 1}
                ></a>
              ) : (
                <a
                  target="_blank"
                  className="h-[26px] w-[102px] bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con_active.svg)]"
                  href={`${resourceData.projectConfigVO.lcscWwwUrl}/catalog/config.html?catalogId=${sonCatalog.catalogId}`}
                  data-spm={pIdx + 1}
                ></a>
              );
            }
            const itemClass = 'font-bold text-[14px] hover:text-lcBlue custom-group';
            return (
              <section className={`${isMroSubCatalog ? 'mb-[10px]' : 'mb-[16px]'}`} key={sonCatalog.catalogId}>
                <section className="flex items-center justify-between">
                  {isBomChildPage ? (
                    <a
                      target="_blank"
                      className={itemClass}
                      href={`${resourceData.projectConfigVO.lcscBomUrl}/bom/model/change-catalog-search/${sonCatalog.catalogId}.html?${location.search.slice(1)}`}
                      data-spm={pIdx + 1}
                    >
                      <span className="mr-[13px]" title={sonCatalog.catalogName || sonCatalog.keywordName}>
                        {sonCatalog.catalogName || sonCatalog.keywordName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  ) : isMroSubCatalog ? (
                    <a
                      className={itemClass}
                      href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`}
                      target="_blank"
                      data-spm={pIdx + 1}
                      onClick={() =>
                        headBuriedPoint('PRODUCT_CATALOGUE_1', {
                          hf: `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`,
                          sp: sonCatalog.catalogName,
                        })
                      }
                    >
                      <span className="mr-[13px]" title={sonCatalog.catalogName}>
                        {sonCatalog.catalogName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  ) : (
                    <a
                      href={`${resourceData.projectConfigVO.lcscListUrl}/catalog/${sonCatalog.catalogId}.html`}
                      className={itemClass}
                      target="_blank"
                      data-spm={pIdx + 1}
                      onClick={() =>
                        headBuriedPoint('PRODUCT_CATALOGUE_1', {
                          hf: `${resourceData.projectConfigVO.lcscListUrl}/catalog/${sonCatalog.catalogId}.html`,
                          sp: sonCatalog.catalogName,
                        })
                      }
                    >
                      <span className="mr-[13px]" title={sonCatalog.catalogName}>
                        {sonCatalog.catalogName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  )}
                  {ktxxArea}
                </section>
                <section className={`${isMroSubCatalog ? 'mt-[10px]' : 'mt-[20px]'} flex flex-wrap items-center`}>
                  {sonCatalog.sonCatalogList.map((s_son, idx) => {
                    let itemClassName =
                      'text-[12px] w-[150px] text-[#56657F] mr-[20px] mb-[15px] inline-block truncate hover:text-lcBlue h-[16px] leading-[16px]';
                    if (isMroSubCatalog) {
                      itemClassName += ' !w-[80px] !mb-[10px]';
                    }
                    return isBomChildPage ? (
                      <a
                        className={itemClassName}
                        href={`${resourceData.projectConfigVO.lcscBomUrl}/bom/model/change-catalog-search/${s_son.catalogId}.html?${location.search.slice(1)}`}
                        target="_blank"
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    ) : isMroSubCatalog ? (
                      <a
                        className={itemClassName}
                        href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${s_son.mroCatalogId}.html`}
                        target="_blank"
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${s_son.mroCatalogId}.html`,
                            sp: s_son.catalogName,
                          })
                        }
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    ) : (
                      <a
                        target="_blank"
                        href={`${resourceData.projectConfigVO.lcscListUrl}/catalog/${s_son.catalogId}.html`}
                        className={itemClassName}
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: `${resourceData.projectConfigVO.lcscListUrl}/catalog/${s_son.catalogId}.html`,
                            sp: s_son.catalogName,
                          })
                        }
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    );
                  })}
                  {(sonCatalog.keywordVOList || []).map((s_son, idx) => {
                    let itemClassName =
                      'mb-[15px] mr-[20px] inline-block w-[150px] truncate text-[12px] text-[#199FE9]';
                    if (isMroSubCatalog) {
                      itemClassName += ' !w-[80px] !mb-[10px]';
                    }
                    return (
                      <a
                        target="_blank"
                        href={s_son.keywordUrl}
                        className={itemClassName}
                        key={s_son.keywordUrl}
                        title={s_son.keywordName}
                        data-spm={pIdx + 1 + '-' + ((sonCatalog?.sonCatalogList?.length || 0) + idx + 1)}
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: s_son.keywordUrl,
                            sp: s_son.keywordName,
                          })
                        }
                      >
                        {s_son.keywordName}
                      </a>
                    );
                  })}
                </section>
                {(sonCatalog.catalogTagVOList || []).map((s_son, idx) => {
                  let itemClassName = 'line-clamp-1 h-[25px] w-[150px] truncate text-center leading-[25px]';
                  if (isMroSubCatalog) {
                    itemClassName += ' !w-[80px]';
                  }
                  return (
                    <div
                      key={s_son.catalogTagName}
                      className={`${
                        s_son.logName === 'hot'
                          ? 'bg-[#fee] text-[#f4220f]'
                          : s_son.logName === 'recommend'
                            ? 'bg-[#FFEFE6] text-[#ff5901]'
                            : s_son.logName === 'domestic'
                              ? 'bg-[#E5EEFF] text-[#0556F5]'
                              : 'bg-[#e7f6ff] text-[#199FE9]'
                      } relative mb-[15px] mr-[20px] inline-block overflow-visible rounded-[3px] text-[12px] text-[#199FE9]`}
                    >
                      <a
                        href={`${s_son.catalogUrl}`}
                        title={s_son.catalogTagName}
                        className={itemClassName}
                        target="_blank"
                        data-spm={
                          pIdx +
                          1 +
                          '-' +
                          ((sonCatalog?.sonCatalogList?.length || 0) +
                            (sonCatalog?.keywordVOList?.length || 0) +
                            idx +
                            1)
                        }
                        onClick={() =>
                          headBuriedPoint('catalog_marketing_tag', {
                            hf: s_son.catalogUrl,
                            sp: s_son.catalogTagName,
                            user_type: Utils.isLogined() ? 1 : 0,
                            catalog_id: s_son.catalog_id,
                          })
                        }
                      >
                        {s_son.catalogTagName}
                      </a>
                      {s_son.logName ? (
                        <picture>
                          <img
                            alt={s_son.logName}
                            src={`https://static.szlcsc.com/ecp/assets/newWeb/header/${s_son.logName}.svg`}
                            className={`absolute right-[-10px] top-[-10px] z-[1] h-[16px] w-[29px]`}
                          />
                        </picture>
                      ) : null}
                    </div>
                  );
                })}
              </section>
            );
          })}
        </section>
      </CustomScrollbar>
    </section>
  );
};

const CatalogsPop = ({ resourceData, onlySScreen }) => {
  const [subCatalogVisible, setSubCatalogVisible] = useState(false);
  const [subCatalogList, setSubCatalogList] = useState(null);
  const [currentParentName, setCurrentParentName] = useState(null);
  const [currentParentId, setCurrentParentId] = useState(null);
  const [currentParentIdx, setCurrentParentIdx] = useState(null);

  const { catalogList } = useContext(LayoutContext);

  if (catalogList) {
    const finalCatalogList = [];
    for (const key in catalogList) {
      if (Object.hasOwnProperty.call(catalogList, key)) {
        const element = catalogList[key];
        if (finalCatalogList.length < 15) {
          finalCatalogList.push(element);
        }
      }
    }

    const showSubCatalog = (sonCatalogList, parentName, parentId, parentIdx) => {
      setCurrentParentName(parentName);
      setCurrentParentId(parentId);
      setSubCatalogVisible(true);
      setCurrentParentIdx(parentIdx);
      setSubCatalogList(sonCatalogList);
    };

    const hideSubCatalog = () => {
      setSubCatalogList([]);
      setSubCatalogVisible(false);
      setCurrentParentName(null);
      setCurrentParentIdx(null);
    };

    const gkdqTargetId = Utils.findFirstMroCatalogId(catalogList, '工控电气');

    return (
      <div onMouseLeave={hideSubCatalog}>
        <ul className={`relative`}>
          {finalCatalogList.map((value, idx) => {
            return (
              <li
                key={value.catalogId}
                className={`h-[32px] w-full pl-[10px] leading-[32px] ${currentParentName === value.catalogName ? 'text-[#0093E6]' : ''} custom-group relative cursor-pointer rounded-l-[8px] hover:bg-[#e6f6ff]`}
                onMouseEnter={() => showSubCatalog(value.sonCatalogList, value.catalogName, value.catalogId, idx + 1)}
              >
                {value.catalogName.includes('工业品') || value.catalogName.includes('仪器仪表') ? (
                  <a
                    className="industrial inline-block h-full w-full"
                    data-title={value.catalogName}
                    title={value.catalogName}
                    href={
                      value.catalogName.includes('仪器仪表') && gkdqTargetId
                        ? `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${gkdqTargetId}.html`
                        : resourceData.projectConfigVO.lcscMroUrl
                    }
                    target="_blank"
                  >
                    {value.catalogName}
                    {value.isNew && (
                      <SvgIcon app="common" iconName="upnew" className="ml-[5px] inline-block size-[24px]" />
                    )}
                  </a>
                ) : (
                  <div className="industrial" title={value.catalogName} data-title={value.catalogName}>
                    {value.catalogName}
                    {value.isNew && (
                      <SvgIcon app="common" iconName="upnew" className="ml-[5px] inline-block size-[24px]" />
                    )}
                  </div>
                )}
              </li>
            );
          })}
          <li>
            {subCatalogVisible && (
              <SubCatalogPop
                key={currentParentName}
                onlySScreen={onlySScreen}
                subCatalogList={subCatalogList}
                currentParentName={currentParentName}
                currentParentId={currentParentId}
                currentParentIdx={currentParentIdx}
                resourceData={resourceData}
              />
            )}
          </li>
        </ul>
        <div className="absolute right-[-10px] top-0 h-full w-[10px]"></div>
      </div>
    );
  }
  return <div>暂无数据</div>;
};

export default CatalogsPop;
